import React from 'react';
import { BlinkingDot } from './animated-cursor.styled';

export const AnimatedCursor: React.FC = () => {
  return <BlinkingDot />;
};
